import React, { useState } from 'react';

import { Button } from '../../design/components';
import AuthDialog from '../Auth/AuthDialog';
import { signInWithGoogle } from '../Auth/authHelpers';
import { auth, googleProvider } from '../Recipe/Firebase/InitialiseFirebase';
import { useToast } from '../../design/components';

/**
 * Pre-login editorial landing.
 * Stamp pill (eyebrow) → headline → lede → CTA → three feature cards.
 * "Continue with Google" opens the Google popup directly; "Sign in" opens
 * the email/password dialog (also offers Google).
 */
const PreLogin: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { show } = useToast();
  return (
  <main className="rr-prelogin">
    <div className="rr-prelogin-inner">
      <span className="rr-prelogin-stamp">
        <span className="rr-prelogin-stamp-dot" aria-hidden="true" />
        Cook from a phone. No 30-paragraph life story.
      </span>
      <h1 className="rr-prelogin-headline">
        Paste a link.
        <br />
        Keep the <em>recipe</em>.
      </h1>
      <p className="rr-prelogin-lede">
        Recipe Rack turns any cooking URL into a clean, cookable card. Stack
        them on racks. Cook from your phone. Share with a tap.
      </p>
      <div className="rr-prelogin-cta">
        <Button
          variant="tomato"
          onClick={() => {
            signInWithGoogle(auth, googleProvider).catch((e) =>
              show(e?.message ?? 'Sign-in failed', 'error')
            );
          }}
        >
          Continue with Google
        </Button>
        <Button
          variant="ghost"
          onClick={() => setDialogOpen(true)}
        >
          Sign in
        </Button>
      </div>

      <section className="rr-prelogin-features" aria-label="What you get">
        <article className="rr-prelogin-feature">
          <div className="rr-prelogin-feature-eyebrow">01 / PASTE</div>
          <h2 className="rr-prelogin-feature-title">Paste any URL</h2>
          <p className="rr-prelogin-feature-body">
            A blog, a creator's site, an Instagram reel. We grab the page in
            the background and turn it into a clean card.
          </p>
        </article>
        <article className="rr-prelogin-feature">
          <div className="rr-prelogin-feature-eyebrow">02 / EXTRACT</div>
          <h2 className="rr-prelogin-feature-title">Sensible units</h2>
          <p className="rr-prelogin-feature-body">
            Ingredients and method, structured. Quantities scale with a
            servings stepper; metric and imperial both behave.
          </p>
        </article>
        <article className="rr-prelogin-feature">
          <div className="rr-prelogin-feature-eyebrow">03 / SHELVE</div>
          <h2 className="rr-prelogin-feature-title">Your private library</h2>
          <p className="rr-prelogin-feature-body">
            No public profile, no algorithm. Just your shelf, your racks, on
            every device you cook from.
          </p>
        </article>
      </section>
    </div>
    <AuthDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
  </main>
  );
};

export default PreLogin;
